const MIN_DISTANCE = 60;

function addStartingLine(path: SVGPathElement, startArea: any) {
  const pathLength = path.getTotalLength();
  if (pathLength < 1) return;
  const newPath = startArea;

  const startDistance = pathLength * 0.07; // start at 5% of the path length

  newPath?.setAttribute("stroke-dasharray", `${pathLength} ${pathLength}`);
  newPath?.setAttribute("stroke-dashoffset", `${pathLength - startDistance}`);
  const endPoint = path.getPointAtLength(startDistance);

  const midpointDistance = startDistance - 120;
  const midpoint = path.getPointAtLength(midpointDistance);
  const textX = midpoint.x;

  const trackMidDistance = pathLength * 0.5;
  const trackMidpoint = path.getPointAtLength(trackMidDistance);

  const text = document.getElementById("startText");
  const fontSize = 36; // Set the font size to 16 pixels

  const textY = midpoint.y + fontSize / 2;
  text?.setAttribute("x", textX.toString());
  text?.setAttribute("y", textY.toString());

  // Calculate the tangent angle of the path at the midpoint of the highlighted portion
  const pathTangent = path.getPointAtLength(midpointDistance - 1);
  const pathAngle =
    (Math.atan2(pathTangent.y - midpoint.y, pathTangent.x - midpoint.x) * 180) /
    Math.PI;

  // Rotate the text to match the slope of the path
  text?.setAttribute(
    "transform",
    `rotate(${pathAngle + 180}, ${textX}, ${textY})`
  );

  // create a new path element with the duplicated section

  const closestPoint = endPoint; // start in the middle and work outward

  const slope = getSlope(path, closestPoint.x);

  // Calculate the coordinates of the starting point of the stripe
  const stripeWidth = 88; // replace with the desired width of the stripe
  const stripeHeight = 72; // replace with the desired height of the stripe

  const guardWidth = 400; // replace with the desired width of the stripe
  const guardHeight = 400; // replace with the desired height of the stripe

  const startX = closestPoint.x - stripeWidth / 2;
  const startY = closestPoint.y - stripeHeight / 2;

  const midpointX = trackMidpoint.x - guardWidth / 2;
  const midpointY = trackMidpoint.y - guardHeight / 2;

  // Create a rectangle element for the stripe
  const rect = document.getElementById("line");
  rect?.setAttribute("x", startX.toString());
  rect?.setAttribute("y", startY.toString());
  rect?.setAttribute("width", stripeWidth.toString());
  rect?.setAttribute("height", stripeHeight.toString());

  const guard = document.getElementById("mid-guard");
  guard?.setAttribute("x", midpointX.toString());
  guard?.setAttribute("y", midpointY.toString());
  guard?.setAttribute("width", guardWidth.toString());
  guard?.setAttribute("height", guardHeight.toString());

  const bg = document.getElementById("line-bg");
  bg?.setAttribute("x", startX.toString());
  bg?.setAttribute("y", startY.toString());
  bg?.setAttribute("width", stripeWidth.toString());
  bg?.setAttribute("height", stripeHeight.toString());
  bg?.setAttribute("fill", "white");
  // Calculate the angle of rotation for the stripe
  const perpendicularSlope = -1 / slope;
  const theta = Math.atan(perpendicularSlope);
  let degrees = (theta * 180) / Math.PI;

  // console.warn({ slope, theta, degrees });

  if (slope < 0 && degrees < 0) {
    degrees += 180;
  } else if (slope > 0 && degrees > 0) {
    degrees -= 180;
  }

  rect?.setAttribute(
    "transform",
    `rotate(${degrees} ${startX + stripeWidth / 2} ${
      startY + stripeHeight / 2
    })`
  );
  bg?.setAttribute(
    "transform",
    `rotate(${degrees} ${startX + stripeWidth / 2} ${
      startY + stripeHeight / 2
    })`
  );
}

// Distance function
function distance(p1: { x: number; y: number }, p2: { x: number; y: number }) {
  const dx = p1.x - p2.x;
  const dy = p1.y - p2.y;
  return Math.sqrt(dx * dx + dy * dy);
}

// Get the slope of the path at a specific x coordinate
function getSlope(path: SVGPathElement, x: number) {
  const length = MIN_DISTANCE * 10;
  const resolution = 0.1; // increase for higher accuracy, but slower performance
  let start = 0;
  let end = length;
  while (end - start > resolution) {
    const mid = (start + end) / 2;
    const midPoint = path.getPointAtLength(mid);
    if (midPoint.x < x) {
      start = mid;
    } else {
      end = mid;
    }
  }
  const startPoint = path.getPointAtLength(start);
  const endPoint = path.getPointAtLength(end);
  return (endPoint.y - startPoint.y) / (endPoint.x - startPoint.x);
}

export default addStartingLine;
